export default __webpack_public_path__ + "static/media/866.23351a6b.png";